var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.classes, { 'd-none' : _vm.isHidden }],on:{"click":_vm.onBackHandler}},[_c('font-awesome-icon',{attrs:{"icon":"chevron-left","size":"xs"}}),_vm._v(" "),_vm._t("default",function(){return [_vm._v("Back")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }